import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/page-image/cxcyqy/banner.png';
const _hoisted_1 = {
  class: "cxcyqy-wrapper"
};
const _hoisted_2 = {
  class: "cxcyqy-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_5 = {
  key: 1,
  class: "company-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "company-name"
};
const _hoisted_8 = {
  class: "company-date"
};
const _hoisted_9 = {
  key: 2,
  class: "empty-wrapper"
};
const _hoisted_10 = {
  key: 3,
  class: "pagination"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getEntrepreneurshipList } from '@/api/entrepreneurship';
export default /*@__PURE__*/_defineComponent({
  __name: 'Cxcyqy',
  setup(__props) {
    const router = useRouter();
    const currentPage = ref(1);
    const pageSize = ref(15);
    const total = ref(0);
    const companyList = ref([]);
    const loading = ref(false);
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    // 获取企业列表
    const fetchCompanyList = async () => {
      try {
        loading.value = true;
        const res = await getEntrepreneurshipList({
          pageNum: currentPage.value,
          pageSize: pageSize.value
        });
        if (res.code === 200 || res.code === 0) {
          companyList.value = res.data || [];
          total.value = res.total || 0;
        }
      } catch (error) {
        console.error('获取企业列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 分页切换
    const handlePageChange = page => {
      currentPage.value = page;
      fetchCompanyList();
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/cxcyqy/${id}`);
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchCompanyList();
    });
    return (_ctx, _cache) => {
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "创新创业企业",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SectionTitle, {
        title: "企业列表",
        showMore: false
      }), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : companyList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, company => {
        return _openBlock(), _createElementBlock("div", {
          class: "company-item",
          key: company.id,
          onClick: $event => goToDetail(company.id)
        }, [_createElementVNode("div", _hoisted_7, _toDisplayString(company.name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(formatDate(company.settledTime)), 1)], 8, _hoisted_6);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无企业数据", -1)]))])), total.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: total.value,
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "page-size", "current-page"])])) : _createCommentVNode("", true)])]), _createVNode(_component_Footer)]);
    };
  }
});